import { defineStore } from 'pinia';
import useCommonStore from '@/common/store/pinia/common';
import { VhsTaskResponse } from '@schema';
import { store } from '@/common/root';
import vhsNotificationHandler from '@/common/utils/vhsNotificationHandler';
import { formatTimeAgo } from '@vueuse/core';
import { convertToIso } from '@/common/utils/date';
import i18n from '@/common/i18n';

const mapper = (item: VhsTaskResponse) => {
  const node = store.getters['nodes/getItemById'](item.node_id);
  const createdAgo = formatTimeAgo(new Date(convertToIso(item.created_at) as string));
  const completedAgo = item.completed_at ? formatTimeAgo(new Date(convertToIso(item.completed_at) as string)) : i18n.t('figure dash');

  return {
    ...item,
    nodeName: node?.name,
    createdAgo,
    completedAgo
  };
};

export type VhsTask = ReturnType<typeof mapper>;

export const useVhsTasksStore = defineStore('vhsTasks', () => {
  const commonStore = useCommonStore<VhsTaskResponse, VhsTask>({
    getUrl: () => '/api/v2/vhs/tasks',
    itemKey: 'task_id',
    mapItem: mapper,
  })();

  const takeLastItem = async ({ id }: { id: string }): Promise<void> => commonStore.fetchLastItem(id);

  const onSocket = vhsNotificationHandler('vhs task', {
    created: takeLastItem,
    updated: takeLastItem,
    deleted: ({ id }) => commonStore.abortAndRemoveItem(id),
  });

  return {
    ...commonStore,
    onSocket
  };
}, {
  ws: {
    vhs: 'onSocket'
  }
});

export default useVhsTasksStore;
